import { Exception, IArgumentType } from '@ch-types/Exception';
import _ from 'lodash';

export interface ICoralArgumentType extends IArgumentType {
    type: string;
}

export class CoralException extends Exception {
    public type: string;

    /* istanbul ignore next */
    constructor(args: ICoralArgumentType) {
        super(args);
        this.type = args.type;
    }

    public getType(): string {
        return this.type;
    }

    /*
     * Override Exception's toString() method to include type.
     * Returns a string representation of the top level exception and its nested exceptions.
     */
    public toString(): string {
        const exceptions = [];
        exceptions.push(this);

        let currentException = this.getCause();
        while (currentException) {
            exceptions.push(currentException);
            currentException = currentException.getCause();
        }
        let stackTrace;
        _.each(exceptions.reverse(), (exception) => {
            stackTrace = {
                message: exception.getMessage(),
                cause: stackTrace,
                type: exception.type,
            };
        });
        return JSON.stringify(stackTrace, null, 4);
    }
}
